import http from '@/services/http'
import { addressUrl } from '@/services/url'
import type * as Types from './types'
import { MAX_ADDRESS_COUNT } from '@/constants'
import type { IFormValues } from '@/containers/Order/Create/type'
import { formatAddressBookItemFormConsigneeAddress, formatAddressBookItemFormRefundAddress } from '@/utils'
import type { AddressInfoType, AddressVerifyReqDTO, ValidResult } from './types'
/**
 * 获取地址配置信息
 * @returns
 */
export const getAddressConf = async () => await http.admin.post(addressUrl.addressConfig)

/**
 * 地址校验接口
 * @returns
 */
export const getAddressVerify = async (data: AddressVerifyReqDTO) =>
  await http.admin.post<{
    validResults?: ValidResult[]
  }>('/api/countries/verify-address', data)

/** 地址智能识别 */
export const getAddressAutoSplitResult = async (params: Types.AutoSplitAddressReq[], sceneId?: string) => {
  const { data } = await http.admin.post<{ output: Types.AutoSplitAddressType[] }>('/api/address-service/split/smart-split', {
    input: params,
    sourceSystem: 'ONEWAREHOUSE',
    sceneId,
  })
  return data?.output || []
}

/** 获取支持拆分算法的国家 */
export const getSupportAutoSplitCountryList = async () => {
  const { data } = await http.admin.post<{ items: Types.SplitSupportCountryType[] }>('/api/address-service/split/support', { sourceSystem: 'ONEWAREHOUSE' })
  return data?.items
}

export const getAddressList = async (addressType: Types.AddressType = 2) => {
  const { data } = await http.admin.post<Types.AddressListResponse>(addressUrl.addressList, { addressType, pageSize: MAX_ADDRESS_COUNT })

  return data
}

export const saveAddresses = async (payload: Types.AddressSaveRequest) => http.admin.post('/api/address-books/save', payload)

export const saveConsigneeAddress = async (payload: IFormValues) =>
  saveAddresses({
    add: [formatAddressBookItemFormConsigneeAddress(payload)],
  })

/** 保存退件地址到地址簿 */
export const saveRefundAddress = async (payload: AddressInfoType) =>
  saveAddresses({
    add: [formatAddressBookItemFormRefundAddress(payload)],
  })

export const getAddressConfig = () => http.admin.post<Types.AddressConfigType>(addressUrl.addressConfig)

export const getAreaList = (countryCode: string) => http.admin.get<Types.AreaResponse>(addressUrl.list, { params: { countryCode } })
